import React from "react";
import cx from "classnames";

type Props = {
  title?: string;
  signature?: string;
  message?: string | null;
  subtitle?: string;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  [key: string]: any;
};

const CheckoutInstructions = ({
  title,
  subtitle,
  signature,
  message,
  className,
  ...props
}: Props) => {
  if (!message) {
    return null;
  }
  const wrapperClasses = cx(
    className,
    "bg-green-20 border border-green-60 p-lg rounded",
  );
  return (
    <div className={wrapperClasses} {...props}>
      <div className="text-sm font-bold">{title}</div>
      {subtitle && <p className="my-sm text-xs pb-md">{subtitle}</p>}
      <p className="my-sm text-xs">{message}</p>
      {!!signature && (
        /* Note: the signature text below starts with em dash (U+2014) */
        <p className="text-xs">— {signature}</p>
      )}
    </div>
  );
};

export default CheckoutInstructions;
